export default "__VITE_ASSET__93f843fc__"